module.exports = __webpack_public_path__ + "static/media/GERD-GERD follow up-1@3x.03525889.png";